import { LoadablePaint } from '@confluence/loadable';

export const HubSettingsNavigation = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-HubSettingsNavigation" */ './HubSettingsNavigation.tsx'
			)
		).HubSettingsNavigation,
	name: 'HubSettingsNavigation',
});
